Ext.define('SA.model.createimport.LocationFormatValidator', {
    statics: {
        getErrorsForTupleList(tupleList) {
            var validators = tupleList.map(tuple => new SA.model.createimport.LocationFormatValidator(tuple)),
                hasSingleLocationColumn = validator => validator.hasSingleLocationColumn(),
                hasMalformedLocation = validator => validator.hasMalformedLocation(),
                getError = validator => validator.getError();

            return validators.filter(hasSingleLocationColumn).filter(hasMalformedLocation).map(getError);
        }
    },

    constructor(tuple) {
        this.tuple = tuple;
    },

    getError() {
        var unit = this.tuple.getUnit(),
            fileName = this.tuple.getFileName(),
            unitName = SA.data.GeographicUnits.get(unit).singularName,
            formatDescription = SA.data.LocationValueFormats.getDescriptionForUnit(unit);

        return {fileName, unitName, formatDescription};
    },

    hasMalformedLocation() {
        var locationValues = this.tuple.getLocationColumnValues(),
            formatRegex = SA.data.LocationValueFormats.getRegexForUnit(this.tuple.getUnit()),
            isMalformedValue = locationValue => !formatRegex.test(locationValue);

        return locationValues.some(isMalformedValue);
    },

    hasSingleLocationColumn() {
        return this.tuple.getLocationColumnCount() === 1;
    }
});